import React from 'react'

export const Icon = ({ src, classes = '' }) => {
	return <img src={src} alt="icon" className={classes} />
}
